import { Navigation, Footer } from "../components/landing/Layout";
import { Shield, Bell, Lock, Heart, Users, Star, Eye } from "lucide-react";
import { useCMSContent } from "../hooks/useCMSContent";

const ICONS = { Lock, Bell, Shield, Heart, Users, Star, Eye };

// iter65 fase 2 — página 100% CMS (about_json), editable en Admin → Contenido Web → Página Nosotros
export default function About() {
  const { data: a } = useCMSContent("about_json");
  const c = a || {};
  return (
    <div className="min-h-screen bg-slate-50" data-testid="about-page">
      <Navigation />

      <section className="bg-[#0B2545] py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4" style={{ fontFamily: "Manrope, sans-serif" }} data-testid="about-hero-title">
            {c.hero_title || "Nosotros"}
          </h1>
          <p className="text-slate-300 text-lg max-w-2xl mx-auto" data-testid="about-hero-subtitle">
            {c.hero_subtitle || ""}
          </p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <div className="bg-white rounded-2xl border border-slate-200 p-6" data-testid="about-history-card">
            <h2 className="text-lg font-bold text-[#0B2545] mb-2" style={{ fontFamily: "Manrope, sans-serif" }}>{c.history_title || "Nuestra historia"}</h2>
            <p className="text-slate-600 whitespace-pre-line" data-testid="about-history-text">
              {c.history_text || ""}
            </p>
          </div>

          <div className="grid sm:grid-cols-3 gap-4">
            {(c.values || []).map((v, i) => {
              const Icon = ICONS[v.icon] || Shield;
              return (
                <div key={i} className="bg-white rounded-2xl border border-slate-200 p-5 text-center" data-testid={`about-value-${i}`}>
                  <Icon className="w-7 h-7 mx-auto mb-2 text-[#1B84FF]" />
                  <h3 className="font-semibold text-[#0B2545] mb-1">{v.title}</h3>
                  <p className="text-slate-500 text-sm">{v.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
